import { SourceIcon } from '#pplx/frontend/apps/ask/sources/components/SourceIcon.js';
import { createPlugin } from '#pplx/frontend/composer-sdk/plugins/createPlugin.js';
import { createElement } from 'react';
export const sourceMentionIconPlugin = createPlugin({
    id: 'discover-article-source-mention-icon',
    capabilities: [
        {
            kind: 'mention',
            configure: () => ({
                renderIcon: ({ sourceId }) => createElement(SourceIcon, { sourceId, size: 'small' }),
            }),
        },
    ],
});
//# sourceMappingURL=index.js.map